export default __webpack_public_path__ + "static/media/gallery_04.62e0c0a2.jpg";